<template>
    <div  class="application wow">
      <div class="background">
        <img src="@/assets/bg.jpg" alt="">
      </div>
      <div class="joke1">
        <div class="left">
          <div class="title wow fadeInUp">
              <p class="en">{{$t('home').application.text0}}</p>
              <p class="cn">{{$t('home').application.text1}}</p>
          </div>
          <div class="content wow fadeInUp">
            <p>{{$t('home').application.text2}}</p>
            <p>{{$t('home').application.text3}}</p>
          </div>
          <div class="joke wow fadeInUp">
            <div class="item" v-for="(item, index) in alist" :key="index" @mouseover="getActive($event,index)" @mouseleave="getActive2($event)" @click="gotoInfo(item.id)">
              <div class="bg">
                <img src="@/assets/bg1.png" alt="">
                <img src="@/assets/bg2.png" alt="">
              </div>
              <div :class="item.icon"></div>
              <p>{{item.cn}}</p>
              <p>{{item.en}}</p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="circle"></div>
          <div class="allImg">
              <swiper :options="swiperOptionTop" class="app" ref="swiperTop">
                <swiper-slide class="item" v-for="(item,index) in slist" :key="index">
                    <img :src="item.img" alt="">
                </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import { getClass} from '../util/lang'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "application",
        data(){
          return{
              swiperOptionTop: {
                    notNextTick: true,
                    slidesPerView:1,//一行显示3个
                    speed:1000,
                    init:false,
                    loop:false,
                    setWrapperSize :true,
                    autoplay: false,
                    effect : 'fade',
                    fadeEffect: {
                      crossFade: true,
                    },
                },
              alist: [{icon:"iconfont icon-gongcheng",cn:"工程机械解决方案",en:"construction machinerya",id:"24"},
              {icon:"iconfont icon-36gongyegongcheng_jichuangjiagong",cn:"机床解决方案",en:"machine tool",id:"66"},
              {icon:"iconfont icon-chilun",cn:"齿轮箱解决方案",en:"Gearbox",id:"67"},
              {icon:"iconfont icon-erjiyasuojichuanganqiguzhang",cn:"压缩机解决方案",en:"compressor",id:"68"},
              {icon:"iconfont icon-chujiagongjixie",cn:"轧机解决方案",en:"rolling mill",id:"69"}],
              slist: [{img:require('@/assets/11.png')},
                      {img:require('@/assets/12.png')},
                      {img:require('@/assets/13.png')},
                      {img:require('@/assets/14.png')},
                      {img:require('@/assets/15.png')}]
          }
        },
        components:{swiper, swiperSlide},
        mounted(){
            this.$nextTick(()=>{
                this.$refs.swiperTop.swiper.init()
                // const swiperTop = this.$refs.swiperTop.swiper
                if(this.$i18n.locale==='en'){
                    this.getList('122')
                }else{
                    this.getList('22')
                }
            })
        },
        methods:{
          getActive($event,index) {
            $event.currentTarget.className = 'item active';
            this.$refs.swiperTop.swiper.slideToLoop(index)
          },
          gotoInfo(id){
                const link=`/solutionInfo.html?id=${id}`
                window.open(link,'_self')
          },
          getActive2($event) {
            $event.currentTarget.className = 'item';
          },
            getList(id){
                const url = `${getClass(id)}`
                this.$axios.get(url).then(res => {
                    res.data.data.pop()
                    this.list=res.data.data
                  // console.log(res.data.data)
                })
            },
        }
    }
</script>

<style lang="scss" scoped>

  .application {
    width: 100%;
    position: relative;
    z-index: 1;
    padding-top: 170px;
    display: flex;
    justify-content: center;
    .joke1 {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .left {
        .title {
          margin-bottom: 107px;
          .en {
            font-size: 50px;
            font-family: "DINEngschriftStd";
            text-transform: uppercase;
            font-weight: normal;
            color: #333333;
            margin-bottom: 29px;
          }
          .cn {
            font-size: 25px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            position: relative;
            &::after {
              content: "";
              width: 22px;
              height: 5px;
              background: #FDCC49;
              position: absolute;
              left: 0;
              top: 57px;
            }
          }
        }
        .content {
          margin-bottom: 129px;
          p {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
          }
          p:nth-child(1) {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin-bottom: 29px;
          }
        }
        .joke {
          display: flex;
          margin-bottom: 123px;
          .item {
            cursor: pointer;
            width: 135px;
            height: 260px;
            position: relative;
            margin-right: 40px;
            p:nth-of-type(1) {
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              width: 18px;
              line-height: 20px;
              height: auto;
              word-wrap: break-word;
              margin: 20px 0 0 81px;
            }
            p:nth-of-type(2) {
              width: 170px;
              position: absolute;
              top: 156px;
              right: -64px;
              font-size: 14px;
              font-family: "it";
              font-weight: normal;
              color: #666666;
              transform: rotate(90deg);
              white-space: nowrap;
            }
            .iconfont {
              font-size: 30px;
              color: #666;
              margin: 27px 0 0 26px;
              transition: 0.6s;
            }
            .bg {
              width: 100%;
              height: 100%;
              position: absolute;
              z-index: -1;
              img {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                transition: 0.6s;
              }
              img:nth-child(1) {
                opacity: 0;
              }
              img:nth-child(2) {
                opacity: 1;
              }
            }
          }
          .active {
            .iconfont {
              color: #fff;
            }
            .bg {
              img:nth-child(1) {
                opacity: 1;
              }
              img:nth-child(2) {
                opacity: 0;
              }
            }
          }
          item:nth-last-child(1) {
            margin-right: 0;
          }
        }
    }
    .right {
      margin-left: 75px;
      position: relative;
      .circle {
        position: absolute;
        top: 0;
        right: -85px;
        width: 661px;
        height: 661px;
        background: #F6C02E;
        border-radius: 50%;
      }
      .app {
        width: 660px;
      }
    }
  }
@media screen and (max-width: 1800px){
  .application .joke1 .left {
    width: 54%;
  }
  .application .joke1 .left .joke {
    width: 100%;
    justify-content: space-between;

  }
  .application .joke1 .left .joke .item {
    width: 17%;
    margin: 0;
  }
  .application .joke1 .left .joke .item .bg {
    width: 100%;
  }
  .application .joke1 .left .joke .item .bg img {
    width: 100%;
  }
  .application .left .joke .item p:nth-of-type(1) {
    font-size: 14px;
    line-height: 14px;
    margin: 40% 0 0 70%;
  }
  .application .left .joke .item .iconfont {
    margin: 16% 0 0 16%;
  }
  .application .left .joke .item p:nth-of-type(2) {
    width: 150px;
    white-space: unset;
    top: 64%;
    right: -9%;
  }
  .application .right  {
    width: 35%;
    margin-left: 0;
  }
  .application .right .allImg {
    width: 100%;
  }
  .application .right .app {
    width: 100%;
  }
  .application .right .app .item img {
    width: 100%;
  }
  .application .right .circle {
    width: 35vw;
    height: 35vw;
    right: -11%;
  }
}
@media screen and (max-width: 1024px){
  .application .joke1 {
    width: 90%;
    margin: auto;
    flex-direction: column;
  }
  .application .joke1 .left {
    width: 100%;
  }
  .application .joke1 .right {
    width: 90%;
    margin: auto;
  }
  .application .left .title .en {
    font-size: 30px;
    margin-bottom: 15px;
  }
  .application {
    padding-top: 80px;
  }
  .application .left .content p:nth-child(1) {
    font-size: 20px;
  }
  .application .left .title {
    margin-bottom: 70px;
  }
  .application .left .content p {
    font-size: 14px;
  }
  .application .left .content {
    margin-bottom: 60px;
  }
  .application .joke1 .left .joke .item {
    width: 30%;
    margin-right: 3%;
  }
  .application .joke1 .left .joke .item:nth-child(3n) {
    margin-right: 0;
  }
  .application .joke1 .left .joke {
    flex-wrap: wrap;
    justify-content: unset;
    margin-bottom: 10px;
  }
  .application .left .joke .item p:nth-of-type(1){
    font-size: 12px;
    line-height: 12px;
  }
  .application .left .joke .item p:nth-of-type(2) {
    width: 120px;
    font-size: 12px;
    top: 55%;
  }
  .application .right .circle {
    width: 80vw;
    height: 80vw;
    right: -8%;
  }
}
</style>
<style scoped>
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet {
        width:5px;
        height:5px;
        background:#333333;
        border-radius:50%;
        margin-left: 30px;
        transition: all 600ms;
        position: relative;
        opacity: 1;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet::before{
        content:'';
        width:35px;
        height:35px;
        border:1px solid #FECE4A;
        border-radius:50%;
        display: inline-block;
        position: absolute;
        left:-15px;
        top:-15px;
        opacity: 0;
        transition: all 600ms;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet-active{
        background-color:#FECE4A ;
    }
    .lSwiper .swiper-pagination>>>.swiper-pagination-bullet-active::before{
        opacity: 1;
    }
</style>
